import React, { useState, useEffect } from 'react';
import { useAccount } from 'wagmi';
import { Avatar } from '@mui/material';
import Fade from 'react-reveal/Fade';
import { getTopScores } from '../../web3/SFM-ScoreBoardContract_Utils';
import PromptLogin from '../PromptLogin';
import Loader from '../../components/Loader/loader';
import { getAllTeams, getTeamsTopScore } from '../../web3/SFM-TeamsUtils';
import { getImageUrlFromJson } from '../../utils/getImageUrlFromJson';

function LeaderBoardTeam() {
  const { isConnected, address } = useAccount();
  const [topScores, setTopScores] = useState();

  const getScores = React.useCallback(async () => {
    if (isConnected) {
      const allTeams = await getAllTeams();
      const data = [];
      if (allTeams) {
        for (const team of allTeams) {
          let leaderurl = await getImageUrlFromJson(team.leaderURI);
          let memberurl = await getImageUrlFromJson(team.memberURI);
          data.push({
            ...team,
            leaderImage: leaderurl,
            memberImage: memberurl,
          });
        }
        setTopScores(
          data
            .filter(({ score }) => Number(score) > 0)
            .slice()
            .sort((a, b) => Number(b.score) - Number(a.score))
        );
      }
    }
  }, [isConnected, address]);

  React.useEffect(() => {
    isConnected && getScores();
  }, [getScores]);

  return (
    <div className="community-area primary-bg pb-175">
      <div className="container">
        {isConnected ? (
          topScores ? (
            <Fade right delay={0.5}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="community-wrap">
                    <div className="table-responsive-xl">
                      {topScores && topScores.length > 0 ? (
                        <table className="table mt-0">
                          <thead>
                            <tr>
                              <th scope="col">
                                <span className="color-inline">Team</span>
                              </th>
                              <th scope="col">
                                <span className="color-inline">Score</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {topScores.map((elem, index) => (
                              <tr key={index}>
                                <th scope="row">
                                  <div className="community-post-wrap">
                                    <div className="title-style-three text-center d-flex align-items-center">
                                      <Avatar
                                        src={elem.memberImage}
                                        className="float-left mr-1"
                                      />
                                      <h4 className="color-inline mb-0 mt-1">
                                        {elem.name}
                                      </h4>
                                    </div>
                                  </div>
                                </th>

                                <td>
                                  <div className="title-style-three text-center">
                                    <h3 className="color-inline">
                                      {elem.score.toString()}
                                    </h3>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      ) : (
                        <h4 className="text-center  text-dark">
                          No Scores Yet
                        </h4>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          ) : (
            <div className="row justify-content-center">
              <Loader />
            </div>
          )
        ) : (
          <PromptLogin />
        )}
      </div>
    </div>
  );
}

export default LeaderBoardTeam;
